<template>
  <div class="modalback" @click="closeAction">
    <div class="modalcontent container rounded-5" v-on:click.stop="">
      <div class="row justify-content-center align-items-center">
        <div class="col">
          <img
            src="@/assets/acrypro/carticon.png"
            class="img-fluid"
            style="width: 130px"
          />
          <p class="mt-2">再注文</p>
          数量
          <select
                class="text-center selectback border-0"
                name="num_list"
                id="num_list"
                v-model="selectOptionNum"
                style="width:50px"
              >
                <option
                  v-for="num in [...Array(100)].map((_, i) => i + 1)"
                  v-bind:key="num"
                  v-bind:value="num"
                >
                  {{ num }}
                </option>
              </select>
        </div>
      </div>
      <div class="row justify-content-center align-items-end" style="height: 60px">
        <div class="col">
          <button class="acrybtn" @click="okAction">カートに追加</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ReOrderOption_Ap",
  props: {},
  data: function () {
    return {
      selectOptionNum:1
    };
  },
  mounted: function () {
    // 画面の遷移があるか調べる
  },
  methods: {
    okAction() {
      this.$store.state.reorderOptionCallback(this.selectOptionNum)
      this.$store.commit("setReorderOption",false);
    },
    closeAction() {
      this.$store.commit("setReorderOption",false);
    },
  },
  components: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modalback {
  z-index: 200;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  z-index: 201;
  width: 300px;
  height: 320px;
  padding: 1em;
  background-color: white;
}
.acrybtn{
  background:#7F8DB2;
  color: white;
  height: 30px;
  width: 150px;
  border-radius: 15px;
  border: 0;
}
.selectback{
  background-color: #e4e3ea;
}
</style>
